
import { SvgIcon, SvgIconProps } from "@mui/material";
    
export const ExternalLinkIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
   <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="square" stroke-linejoin="round" stroke-width="1.5" d="m16 8-9 9M10 7l6.95.049L17 14"/></svg>
  </SvgIcon>
);
